import { lazy } from "react";

const UserSettings = lazy(() => import("../pages/users/UserSettings"));
const RegisterUser = lazy(() => import("../pages/users/RegisterUser"));
const EditUser = lazy(() => import("../pages/users/EditUser"));
const UserProfile = lazy(() => import("../pages/users/UserProfile"));
const UserAppointments = lazy(() => import("../components/UserAppointments"));
const SalesmanDashboard = lazy(
  () => import("../pages/users/SalesmanDashboard")
);
const Earnings = lazy(() => import("../pages/users/Earnings"));
const RegisterAdmin = lazy(() => import("../pages/users/RegisterAdmin"));

export const usersRoutes = [
  {
    path: "/users/register-user",
    component: RegisterUser,
  },
  {
    path: "/users/edit-user/:id",
    component: EditUser,
  },
  {
    path: "/users/my-dashboard/:id",
    component: UserProfile,
  },
  {
    path: "/users/my-appointments/:id",
    component: UserAppointments,
  },
  {
    path: "/users/salesman/my-dashboard/:id",
    component: SalesmanDashboard,
  },
  {
    path: "/users/my-earnings/:id",
    component: Earnings,
  },
  {
    path: "/users/register-admin",
    component: RegisterAdmin,
  },
  {
    path: "/users/settings/:id",
    component: UserSettings,
  },
];
